import * as React from 'react';

import { AuthNotification } from '../../components/AuthNotification';
import { useAuth } from '../../hooks/useAuth';

export const AuthNotificationContainer: React.FC = () => {
  const { requestAuthentication } = useAuth();

  return <AuthNotification onAuthClick={requestAuthentication} />;
};
